import axios from 'axios';

import { toFromDates, toFromDispatchDates } from '../components/Common/cleanDates';
import {
  REQUEST_SALES_ORDERS_BY_FILTER,
  FETCH_SALES_ORDERS_SUCCESS,
  FETCH_SALES_ORDERS_FAILURE, FETCH_SALES_QUOTES_SUCCESS, REQUEST_SALES_QUOTE_BY_FILTER,
} from './type';
import {
  SALES_ORDERS_URL, MOBILE_SALES_ORDERS_URL, MOBILE_SALES_ORDERS_URL_v2,
  SALES_QUOTE_URL, SALES_ORDER_PREPAY_STATUS_URL,
} from './url';
import {
  ROOT_URL, ROOT_API_URL, isOCM, isGGI, isABBLE, isABCFF, isVAK, isOLG, isKM, isAGD,
  isSV, isSW, isLAP, isUSPrideMulti, isAPD, isSH, isAP, isCCW
} from './root_url';

const isWIZ = ROOT_API_URL === 'https://wiz-scm.truckxi.com/api/' || ROOT_URL === 'https://wiz-scm.truckxi.com/api/';
const isFJ = ROOT_API_URL === 'https://fj-scm.truckxi.com/api/' || ROOT_URL === 'https://fj-scm.truckxi.com/api/';
const isJTB = ROOT_API_URL === 'https://jtb-scm.truckxi.com/api/' || ROOT_URL === 'https://jtb-scm.truckxi.com/api/';
const isAFM =
  ROOT_API_URL === "https://afm-scm.truckxi.com/api/" ||
  ROOT_URL === "https://afm-scm.truckxi.com/api/" ||
  ROOT_API_URL === "https://afmstage-scm.truckxi.com/api/" ||
  ROOT_URL === "https://afmstage-scm.truckxi.com/api/";
const isABC =
  ROOT_API_URL === "https://abc-scm.truckxi.com/api/" ||
  ROOT_URL === "https://abc-scm.truckxi.com/api/";

export function fetchSalesOrdersByFilter(postingDateGT, postingDateLT, days, status, user, productNum, route, dispatchDateGT, dispatchDateLT, dispatchDays, limit, page, searchFilter, orderType, otherParams, callback = () => {}, isNoPage = false) {
  // only fit when search on product
  let isSo = route == 'salesOrders';
  let url = isSo ? SALES_ORDERS_URL : MOBILE_SALES_ORDERS_URL;
  const dates = toFromDates(days, postingDateGT, postingDateLT);
  const dispatchDates = toFromDispatchDates(dispatchDays, dispatchDateGT, dispatchDateLT)
  if (status == 'all') {
    status = '';
  } else {
    //Backlog is not an order status
    if (status === 'Backlog') {
      status = `&backlog=true`
    } else {
      status = `&SaleStatus=${status}`;
    }
  }
  if (user) {
    user = `&Sales_User_id=${user}`;
  } else {
    user = '';
  }

  if (productNum) {
    productNum = `&ProductNum=${productNum}`;
  } else {
    productNum = '';
  }

  let belongWarehouse = ``;
  if ( isAFM ) {
    if (!localStorage.getItem('warehouseLocation') || localStorage.getItem('warehouseLocation') === '' || localStorage.getItem('warehouseLocation') === 'none') {
      belongWarehouse = ``;
    } else {
      belongWarehouse = `&BelongWarehouse=${localStorage.getItem('warehouseLocation')}`;
    }
  }

  let pageL = ``;
  let currentPage = '';
  let pageLimit = '';
  let limitL = ``;
  let soNumL = ``;
  let companyL = ``;
  let fbaL = ``;
  let bolL = ``;
  let isaL = ``;
  let shippingL = ``;
  let containerL = ``;
  let otherParam = "";
  if (((isOCM || isVAK || isOLG || isKM || isSW || isAGD || isSV || isSH || isAP) && route === 'salesOrders') || ((isVAK && !isNoPage || isKM || isABBLE || isAGD || isOLG ) && route === 'mobileSalesOrders')) {
    if (page !== null && page !== undefined) {
      pageL = `&page=${page + 1}`;
      currentPage = page;
    } else {
      pageL = `&page=1`;
      currentPage = 1;
    }
    if (limit !== null && limit !== undefined) {
      limitL = `&limit=${limit}`;
      pageLimit = limit;
    } else {
      limitL = `&limit=99999`;
    }
    if (otherParams) {
      otherParam = `&${otherParams}`
    }
  }

  if ( isABC && route !== 'salesOrders') {
    url = (route == 'salesOrders') ? SALES_ORDERS_URL : MOBILE_SALES_ORDERS_URL_v2;
    if (page) {
      pageL = `&page=${page+1}`;
    } else {
      pageL = `&page=1`;
    }
    if (limit) {
      limitL = `&limit=${limit}`;
    } else {
      limitL = `&limit=99999`;
    }

    // if (searchFilter) {
      if (searchFilter.SONum) {
        soNumL = `&SONum=${searchFilter.SONum}`;
      }
      if (searchFilter.CompanyName) {
        companyL = `&CompanyName=${searchFilter.CompanyName}`;
      }
      if (searchFilter.FBACode) {
        fbaL = `&FBACode=${searchFilter.FBACode}`;
      }
      if (searchFilter.CustomerBOLNo) {
        bolL = `&BOLNum=${searchFilter.CustomerBOLNo}`;
      }
      if (searchFilter.IsaNo) {
        isaL = `&ISANum=${searchFilter.IsaNo}`;
      }
      if (searchFilter.ShippingStatus) {
        shippingL = `&ShippingStatus=${searchFilter.ShippingStatus}`;
      }
      if (searchFilter.ContainerNo) {
        containerL = `&ContainerNum=${searchFilter.ContainerNo}`;
      }
    // }
  }

  let IsOutbound = ``;
  if (isWIZ || isFJ || isJTB || isABCFF) {
    url = SALES_ORDERS_URL;
    if (route === 'salesOrders') {
      IsOutbound = `&IsOutbound=false`;
    } else if (route === 'outboundOrders') {
      IsOutbound = `&IsOutbound=true`;
    } else if (route === 'mobileSalesOrders') {
      IsOutbound = `&IsOutbound=`;
      url = MOBILE_SALES_ORDERS_URL;
    }
  }
  const isMobile = route !== 'salesOrders';

  return (dispatch, getState) => {
    const state = getState();
    if(isVAK && (state.header.selectedCompany || {value:''}).value == 6){
      if(status == '') {
        status = '&IsOutIfStock=true'
      } else if (status === '&SaleStatus=Released') {
        status = '&IsTracking=true&IsOutIfStock=true';
      } else if (status === '&SaleStatus=Unshippedng') {
        status = '&IsTracking=false&Picking=false&IsOutIfStock=true';
        if(orderType == 'Prepay') {
          status = `${status}&PrepayStatus=ReadyToShip`;
        }
      } else if (status === '&SaleStatus=Unshippedg') {
        status = '&IsTracking=false&Picking=true&IsOutIfStock=true';
        if(orderType == 'Prepay') {
          status = `${status}&PrepayStatus=ReadyToShip`;
        }
      } else if (status === '&SaleStatus=Backorder') {
        status = '&SaleStatus=Backorder&IsOutIfStock=true';
      } else if (status === '&SaleStatus=Incomplete') {
        status = '&SaleStatus=Incomplete&IsOutIfStock=true';
      } else if(status === '&SaleStatus=open') {
        status = '&SaleStatus=open&IsOutIfStock=true';
        if(orderType == 'Prepay') {
          status = `${status}&PrepayStatus=WaitForInv`;
        }
      } else if(status === '&SaleStatus=Invoiced' && orderType == 'Prepay') {
        status = '&SaleStatus=open&IsOutIfStock=true&PrepayStatus=WaitForPay';
      } else if(status === '&SaleStatus=Paid' && orderType == 'Prepay') {
        status = '&SaleStatus=open&IsOutIfStock=true&PrepayStatus=ReadyToShip';
      } else if(status === '&SaleStatus=PartialShip' && orderType == 'Prepay') {
        status = '&SaleStatus=open&IsOutIfStock=true&PrepayStatus=PartialShip&IsTracking=false';
      }
      if(!orderType) {
        status = `${status}&Is_Prepay=false`;
      }
    }

    if (state.header.selectedWarehouse.value) {
      dispatch({
        type: REQUEST_SALES_ORDERS_BY_FILTER,
        payload: {
          url,
          dates,
          status,
          user,
          productNum,
          dispatchDates,
          belongWarehouse,
          IsOutbound,
          pageL,
          currentPage,
          pageLimit,
          limitL,
          soNumL,
          companyL,
          fbaL,
          bolL,
          isaL,
          shippingL,
          containerL,
          orderType,
          isMobile,
          otherParam,
          callback,
        },
      });
    }
  };
}

export function fetchSalesQuotesByFilterLap(postingDateGT, postingDateLT, days, status, user, productNum, route, dispatchDateGT, dispatchDateLT, dispatchDays, limit, page, searchFilter, orderType, otherParams) {
  let url = SALES_QUOTE_URL;
  const dates = toFromDates(days, postingDateGT, postingDateLT);
  if (status === 'all') {
    status = '';
  } else {
    status = `&SaleStatus=${status}`;
  }
  if (user) {
    user = `&Sales_User_id=${user}`;
  } else {
    user = '';
  }

  if (productNum) {
    productNum = `&ProductNum=${productNum}`;
  } else {
    productNum = '';
  }

  let belongWarehouse = ``;

  let pageL = ``;
  let currentPage = '';
  let pageLimit = '';
  let limitL = ``;
  let soNumL = ``;
  let companyL = ``;
  let fbaL = ``;
  let bolL = ``;
  let isaL = ``;
  let shippingL = ``;
  let containerL = ``;
  let otherParam = "";

  return (dispatch, getState) => {
    const state = getState();
    if (state.header.selectedWarehouse && state.header.selectedWarehouse.value) {
      dispatch({
        type: REQUEST_SALES_QUOTE_BY_FILTER,
        payload: {
          url,
          dates,
          status,
          user,
          productNum,
          belongWarehouse,
          pageL,
          currentPage,
          pageLimit,
          limitL,
          soNumL,
          companyL,
          fbaL,
          bolL,
          isaL,
          shippingL,
          containerL,
          orderType,
          otherParam,
        },
      });
    }
  };
}


export const searchInvoicesByInvoiceNo = (searchTerm, pathname, limit, page, query = 'search', callback = () => {}) => (dispatch, getstate) => {
  const state = getstate();
  const selectedCompany = state.header.selectedCompany;
  const selectedWarehouse = state.header.selectedWarehouse;

  let url = pathname === '/salesOrders' ? SALES_ORDERS_URL : MOBILE_SALES_ORDERS_URL;
  let params = {};
  params[query] = searchTerm;
  params['Company_id'] = selectedCompany.value;
  if(isVAK && selectedCompany.value == 6) {
    params['IsOutIfStock'] = true;
    params['Pickup_Warehouse_id_id'] = selectedWarehouse.value;
  }
  if (!localStorage.getItem('warehouseLocation') || localStorage.getItem('warehouseLocation') === '') {
    // params['BelongWarehouse'] = ;
  } else {
    params['BelongWarehouse'] = localStorage.getItem('warehouseLocation');
  }


  if ( isABC && pathname !== '/salesOrders') {
    url = pathname === '/salesOrders' ? SALES_ORDERS_URL : MOBILE_SALES_ORDERS_URL_v2;
    if (page) {
      params['page'] = page+1;
    } else {
      params['page'] = 1;
    }
    if (limit) {
      params['limit'] = limit;
    } else {
      params['limit'] = 99999;
    }
  }

  axios.get(`${url}search/`, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    params: params,
  })
    .then((res) => {
      callback();
      dispatch({
        type: FETCH_SALES_ORDERS_SUCCESS, payload: res,
      });
    })
    .catch((err) => {
      dispatch({
        type: FETCH_SALES_ORDERS_FAILURE,
        payload: JSON.stringify(err),
      });
    });
};

export const updatePrepayStatus = (ids, callback = () => {}) => (dispatch, getstate) => {
  axios.post(`${SALES_ORDER_PREPAY_STATUS_URL}${ids}`, {},{
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
    .then((res) => {
      callback();
    })
    .catch((err) => {
     alert(JSON.stringify(err.data))
    });
};

export const searchSalesQuoteByNumLap = (searchTerm, pathname, limit, page, query = 'search') => (dispatch, getstate) => {
  const state = getstate();
  const selectedCompany = state.header.selectedCompany;

  let url = SALES_QUOTE_URL;
  let params = {};
  params[query] = searchTerm;
  params['Company_id'] = selectedCompany.value;
  if (!localStorage.getItem('warehouseLocation') || localStorage.getItem('warehouseLocation') === '') {
    // params['BelongWarehouse'] = ;
  } else {
    params['BelongWarehouse'] = localStorage.getItem('warehouseLocation');
  }

  axios.get(`${url}search/`, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    params: params,
  })
    .then((res) => {
      dispatch({
        type: FETCH_SALES_ORDERS_SUCCESS, payload: res,
      });
    })
    .catch((err) => {
      dispatch({
        type: FETCH_SALES_ORDERS_FAILURE,
        payload: JSON.stringify(err),
      });
    });
};

export const searchInvoicesByTrackingNo = (searchTerm, pathname) => (dispatch) => {
  const url = pathname === '/salesOrders' ? SALES_ORDERS_URL : MOBILE_SALES_ORDERS_URL;
  let params = {};
  params['searchTrackingNo'] = searchTerm;
  if (!localStorage.getItem('warehouseLocation') || localStorage.getItem('warehouseLocation') === '') {
    // params['BelongWarehouse'] = ;
  } else {
    params['BelongWarehouse'] = localStorage.getItem('warehouseLocation');
  }
  axios.get(`${url}search/`, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    params: params,
  })
    .then((res) => {
      dispatch({
        type: FETCH_SALES_ORDERS_SUCCESS, payload: res,
      });
    })
    .catch((err) => {
      dispatch({
        type: FETCH_SALES_ORDERS_FAILURE,
        payload: JSON.stringify(err),
      });
    });
};

export const SalesOrderListEpic = (action$, { getState }) => {
  let savedAction;
  return action$.ofType(REQUEST_SALES_ORDERS_BY_FILTER)
    .switchMap((action) => {
      const state = getState();
      savedAction = action;
      const Pickup_warehouse_id_id = state.header.selectedWarehouse.value;
      const Company_id = state.header.selectedCompany.value;
      let orderType = {};
      if (isOCM || isGGI || isABBLE || isVAK || isLAP || isUSPrideMulti || isCCW || isAP) {
        if (!isAP) {
          orderType.IsTransfer = false;
        }
        orderType.IsRelocation = false;
        if (action.payload.orderType) {
          if(isVAK && action.payload.orderType == 'Prepay') {
            orderType.Is_Prepay = true;
          } else {
            orderType[action.payload.orderType] = true;
          }
        }
      }

      if (isSV) {  //SUNSET isrelocation and istransfer
        orderType = null;
      }
      let url = `${action.payload.url}search/?OrderDate__gte=${action.payload.dates.fromDate
      }&OrderDate__lte=${action.payload.dates.toDate}&DispatchDate__gte=${action.payload.dispatchDates.dispatchDateGT}&DispatchDate__lte=${action.payload.dispatchDates.dispatchDateLT}${action.payload.status}${action.payload.user}${action.payload.productNum}${action.payload.belongWarehouse}${action.payload.IsOutbound}${action.payload.pageL ? action.payload.pageL : ''}${action.payload.limitL ? action.payload.limitL : ''}${action.payload.soNumL ? action.payload.soNumL : ''}${action.payload.companyL ? action.payload.companyL : ''}${action.payload.fbaL ? action.payload.fbaL : ''}${action.payload.containerL ? action.payload.containerL : ''}${action.payload.isaL ? action.payload.isaL : ''}${action.payload.shippingL ? action.payload.shippingL : ''}${action.payload.bolL ? action.payload.bolL : ''}&Pickup_Warehouse_id_id=${Pickup_warehouse_id_id}&Company_id=${Company_id}${action.payload.isMobile ? "" : ``}${action.payload.otherParam ? action.payload.otherParam : ""}`;
      if (isAGD) {
        url = `${action.payload.url}search/?OrderDate__gte=${action.payload.dates.fromDate
        }&OrderDate__lte=${action.payload.dates.toDate}&DispatchDate__gte=${action.payload.dispatchDates.dispatchDateGT}&DispatchDate__lte=${action.payload.dispatchDates.dispatchDateLT}${action.payload.status}${action.payload.user}${action.payload.productNum}${action.payload.belongWarehouse}${action.payload.IsOutbound}${action.payload.pageL ? action.payload.pageL : ''}${action.payload.limitL ? action.payload.limitL : ''}${action.payload.soNumL ? action.payload.soNumL : ''}${action.payload.companyL ? action.payload.companyL : ''}${action.payload.fbaL ? action.payload.fbaL : ''}${action.payload.containerL ? action.payload.containerL : ''}${action.payload.isaL ? action.payload.isaL : ''}${action.payload.shippingL ? action.payload.shippingL : ''}${action.payload.bolL ? action.payload.bolL : ''}&Pickup_Warehouse_id_id=${Pickup_warehouse_id_id}&Company_id=${Company_id}${action.payload.isMobile ? "" : ``}${action.payload.otherParam ? action.payload.otherParam : ""}`;
      }
      return axios.get(
        // `${action.payload.url}search/?OrderDate__gte=${action.payload.dates.fromDate
        // }&OrderDate__lte=${action.payload.dates.toDate}&DispatchDate__gte=${action.payload.dispatchDates.dispatchDateGT}&DispatchDate__lte=${action.payload.dispatchDates.dispatchDateLT}${action.payload.status}${action.payload.user}${action.payload.productNum}${action.payload.belongWarehouse}${action.payload.IsOutbound}${action.payload.pageL ? action.payload.pageL : ''}${action.payload.limitL ? action.payload.limitL : ''}${action.payload.soNumL ? action.payload.soNumL : ''}${action.payload.companyL ? action.payload.companyL : ''}${action.payload.fbaL ? action.payload.fbaL : ''}${action.payload.containerL ? action.payload.containerL : ''}${action.payload.isaL ? action.payload.isaL : ''}${action.payload.shippingL ? action.payload.shippingL : ''}${action.payload.bolL ? action.payload.bolL : ''}&Pickup_Warehouse_id_id=${Pickup_warehouse_id_id}&Company_id=${Company_id}${action.payload.isMobile ? "" : ``}${action.payload.otherParam ? action.payload.otherParam : ""}`, //${action.payload.pageL}${action.payload.limitL}${action.payload.soNum}${action.payload.companyL}${action.payload.fbaL}
        url,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          params: {
            ...orderType,
          }
        },
      )
    })
    .map(response => {
      const payload = response;
      if (isOCM || isKM || isABBLE || isSW || isAGD || isSV || isVAK || isSH || isAP) {
        if (response.data.pages === undefined) {
          payload.data.totalPages = Math.ceil(response.data.Rows / savedAction.payload.pageLimit);
          if (payload.data.totalPages === Infinity) {
            // Infinity totalpages cause issue with pagination
            payload.data.totalPages = 1;
          }
        } else {
          payload.data.totalPages = response.data.pages;
        }
      }
      typeof savedAction.payload.callback === 'function'
      && savedAction.payload.callback();
      return { type: FETCH_SALES_ORDERS_SUCCESS, payload }
    })
    .catch((error, caught) => {
      return caught
    });
}
export const SalesQuoteListEpic = (action$, { getState }) => {
  let savedAction;
  return action$.ofType(REQUEST_SALES_QUOTE_BY_FILTER)
    .switchMap((action) => {
      const state = getState();
      savedAction = action;
      const Pickup_warehouse_id_id = state.header.selectedWarehouse.value;
      const Company_id = state.header.selectedCompany.value;
      let orderType = {};
      return axios.get(
        `${action.payload.url}search/?QuoteDate__gte=${action.payload.dates.fromDate
        }&QuoteDate__lte=${action.payload.dates.toDate}${action.payload.status}${action.payload.user}${action.payload.productNum}${action.payload.belongWarehouse}${action.payload.pageL ? action.payload.pageL : ''}${action.payload.limitL ? action.payload.limitL : ''}${action.payload.soNumL ? action.payload.soNumL : ''}${action.payload.companyL ? action.payload.companyL : ''}${action.payload.fbaL ? action.payload.fbaL : ''}${action.payload.containerL ? action.payload.containerL : ''}${action.payload.isaL ? action.payload.isaL : ''}${action.payload.shippingL ? action.payload.shippingL : ''}${action.payload.bolL ? action.payload.bolL : ''}&Pickup_Warehouse_id_id=${Pickup_warehouse_id_id}&Company_id=${Company_id}${action.payload.isMobile ? "" : ``}${action.payload.otherParam ? action.payload.otherParam : ""}`, //${action.payload.pageL}${action.payload.limitL}${action.payload.soNum}${action.payload.companyL}${action.payload.fbaL}
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          params: {
            ...orderType,
          }
        },
      )
    })
    .map(response => {
      const payload = response;
      return { type: FETCH_SALES_QUOTES_SUCCESS, payload }
    })
    .catch((error, caught) => {
      return caught
    });
}



// WEBPACK FOOTER //
// ./master/jsx/actions/salesOrderList_actions.jsx